import script from "./ForestAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForestAll.vue?vue&type=script&setup=true&lang=ts"

import "./ForestAll.vue?vue&type=style&index=0&id=32254fed&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32254fed"]])

export default __exports__